import { Injectable } from '@angular/core';
import { Meta, MetaDefinition, Title } from '@angular/platform-browser';

@Injectable()
export class MetaService {
    constructor(private metaService: Meta, private titleService: Title){

    }

setMetaTags(pageTitle: string, pageDescription: string, keyWords: string): void {

  // this.titleService.setTitle(pageTitle);

  const title: MetaDefinition   =  { name: 'title', content: pageTitle };
  const description: MetaDefinition = { name: 'description', content: pageDescription };
  const keywords: MetaDefinition = { name: 'keywords', content: keyWords };

  this.metaService.updateTag(title);
  this.metaService.updateTag(description);
  this.metaService.updateTag(keywords);
 }
}



// WEBPACK FOOTER //
// ./src/app/services/meta.service.ts